import React from 'react';
import Canvas from './canvas'
import {
    Input,
    Button,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Navbar,
    Nav,
    NavLink,
    Row,
    Spinner,
    Col,
    Form,
} from 'reactstrap';
import NavBar from '../NavBar/navBar'
import { connect } from "react-redux";
import {
    fetchBuilding,
    saveBuilding,
    deleteBuilding,
    fetchFloor,
    saveFloor,
    deleteFloor,
    fetchRooms,
    saveRoom,
    deleteRoom,
    fetchLocationData,
    fetchFloors,
} from '../../actions';
import { toast, ToastContainer } from 'react-toastify';
import { NavLink as RRNavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import Tour from '../../Tour';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-toastify/dist/ReactToastify.css";
import './addLocations.css';
import radioButtonhighlighted from '../../assets/radioButtonhighlighted.svg'
import radioButton from '../../assets/radioButton.svg'
import listHighlight from '../../assets/list.svg'
import list from '../../assets/list-blue.svg'
import mapLocation from '../../assets/vector-square.svg'
import Draggable from 'react-draggable';

let errorDetails = ""

const initialState = {
    id: "",
    datetime: "",
    description: "",
    selected: [],
    isAddBuildingModalOpen: false,
    isAddFloorModalOpen: false,
    isAddRoomModalOpen: false,
    location: "",
    building: "",
    floor: "",
    buildingId: "",
    floorId: "",
    buildingName: "",
    floorName: "",
    isDeleteModalOpen: false,
    deleteID: "",
    deleteDate: "",
    isDisable: false,
    edit: false,
    floor_plan: "",
    floorPlanName: "Upload FloorPlan*",
    loader: false
}

class AddLocations extends React.Component {
    constructor(props) {
        super(props)
        this.resetData = this.resetData.bind(this)
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            ...initialState,
            isLocationScan: false,
            building: this.props.location.state?this.props.location.state.buildingToShow:"", 
            floor: this.props.location.state? this.props.location.state.floorToShow: "", 
            buildingId: this.props.location.state? this.props.location.state.buildingId: "", 
            floorId: this.props.location.state? this.props.location.state.floorId: "",
            buildingName: this.props.location.state? this.props.location.state.buildingName: "",
            floorName: this.props.location.state? this.props.location.state.floorName: "",
        }
    }

    componentWillUnmount() {
        // Clean up object URLs to prevent memory leaks
        if (this.state.image) {
            URL.revokeObjectURL(this.state.image);
        }
    }

    componentDidMount() {
        // Check if we came from navigation with state
        if (this.props.location && this.props.location.state) {
            const { buildingToShow, floorToShow, buildingName, floorName, floorId, buildingId } = this.props.location.state;
            this.setState({
                building: buildingToShow || this.state.building,
                floor: floorToShow || this.state.floor,
                buildingName: buildingName || this.state.buildingName,
                floorName: floorName || this.state.floorName,
                floorId: floorId || this.state.floorId,
                buildingId: buildingId || this.state.buildingId,
            }, () => {
                this.props.fetchBuilding();
                // If we have a floor from navigation, fetch the floor plan and locations
                if (this.state.floor) {
                    console.log('componentDidMount - Floor from navigation, calling applyfilter');
                    this.applyfilter();
                }
            });
        } else {
            this.props.fetchBuilding();
            // If floor is already set in state (e.g., from previous navigation), fetch locations
            if (this.state.floor) {
                console.log('componentDidMount - Floor already in state, calling applyfilter');
                this.applyfilter();
            }
        }
    }

    onSelectBuilding = (event) => {
        const { value, selectedOptions } = event.target
        this.setState({
            ...this.state,
            building: value,
            buildingId: selectedOptions[0].id,
            buildingName: selectedOptions[0].innerText,
            floor: "",
        }, async () => {
            await this.props.fetchFloors(this.state.building)
        })
    }
  
      onSelectFloor = (event) => {
      const { value, selectedOptions } = event.target
      this.setState({
          ...this.state,
          floor: value,
          floorId: selectedOptions[0].id,
          floorName: selectedOptions[0].innerText,
      }, () => {
          // Automatically fetch floor plan and locations when floor is selected
          if (this.state.floor) {
              console.log('onSelectFloor - Floor selected, calling applyfilter');
              this.applyfilter();
          }
      })
    }
    

    handleChange(event) {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        })
    };

    getRooms = () => {
        this.props.fetchRooms().then(response => {
            if (response.status === 200 && response.data){
                if (appInsights && appInsights.trackTrace) {
                    appInsights.trackTrace({message: 'Rooms List fetched successfully', properties:{page: "addLocations"}, severityLevel: SeverityLevel.Verbose});
                }
                this.setState({rooms: response.data})
            }
            else {
                let message = "Errors in loading rooms data!"
                if (appInsights && appInsights.trackTrace) {
                    appInsights.trackTrace({message: message, properties:{page: "addLocations"}, severityLevel: SeverityLevel.Error});
                }
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) => {
            let message = "Errors in loading rooms data!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations", error: error}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    applyfilter = () => {
        if (this.state.building === '') {
            let message = "Please select a building!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations"}, severityLevel: SeverityLevel.Verbose});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else if (this.state.floor === '') {
            let message = "Please select a floor!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations"}, severityLevel: SeverityLevel.Verbose});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            this.setState({ loader: true })
            this.props.fetchLocationData({ 'floor__id': this.state.floor}).then(response => {
                if (response.status === 200) {
                    if ("locations_data" in response.data) {
                        if (appInsights && appInsights.trackTrace) {
                            appInsights.trackTrace({message: 'Flooplan and Location Data is fetched successfully', properties:{page: "addLocations", name: response.data.locations_data.floor_data.floor_name, id: this.state.floor}, severityLevel: SeverityLevel.Information});
                        }
                        let floor_data = response.data.locations_data.floor_data
                        let floor_width = floor_data.floor_plan_width||1268
                        var img = new Image();
                        img.onload = () =>{
                            this.setState({
                                width: floor_width<img.width?floor_width:img.width,
                                height: floor_width<img.width?(img.height/img.width)*floor_width:img.height
                            })
                        }
                        img.src = floor_data.floor_plan;
                        this.setState({
                            loader: false,
                            floor_plan: floor_data.floor_plan,
                            floor_name: floor_data.floor_name,
                            floor_plan_width: floor_width,
                            building_name: floor_data.building.building_name,
                        })
                    }
                }
                else {
                    this.setState({ loader: false })
                    let message = "Errors in loading locations data!"
                    if (appInsights && appInsights.trackTrace) {
                        appInsights.trackTrace({message: message, properties:{page: "addLocations", name: this.state.floorName, id: this.state.floor}, severityLevel: SeverityLevel.Error});
                    }
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            }).catch((error) => {
                this.setState({ loader: false })
                console.error('Error loading locations data:', error);
                
                let message = "Erro ao carregar dados de localização!";
                
                // More specific error message based on error type
                if (error.response) {
                    const errorData = error.response.data || '';
                    const errorStatus = error.response.status;
                    
                    if (errorStatus === 500) {
                        // Check if error mentions floor_plan
                        if (typeof errorData === 'string' && errorData.includes('floor_plan')) {
                            message = "Este andar não possui um plano de piso cadastrado. Por favor, volte para 'Prédios e Andares' e adicione um plano de piso ao andar antes de mapear salas.";
                        } else {
                            message = "Erro no servidor ao carregar dados. Verifique se o andar possui um plano de piso cadastrado.";
                        }
                    } else if (errorStatus === 404) {
                        message = "Andar não encontrado. Por favor, verifique se o andar existe.";
                    } else if (errorStatus === 400) {
                        message = "Dados inválidos. Verifique os parâmetros da requisição.";
                    }
                } else if (error.message) {
                    message = `Erro ao carregar dados: ${error.message}`;
                }
                
                if (appInsights && appInsights.trackTrace) {
                    appInsights.trackTrace({message: message, properties:{page: "addLocations", error: error, name: this.state.floorName, id: this.state.floor}, severityLevel: SeverityLevel.Error});
                }
                
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 8000
                });
            });
        }
        this.getRooms()
    }

    toggleAddBuildingModal = () => {
        this.setState(prevState => ({
            isAddBuildingModalOpen: !prevState.isAddBuildingModalOpen,
            buildingId: "", 
            buildingName: ""
        }))
    }

    toggleAddFloorModal = () => {
        this.setState(prevState => ({
            isAddFloorModalOpen: !prevState.isAddFloorModalOpen,
            building: "",
            floorId: "",
            floorName: "",
            floorPlan: "",
            floorPlanName: ""
        }))        
    }

    toggleAddRoomModal = () => {
        this.setState(prevState => ({
            isAddRoomModalOpen: !prevState.isAddRoomModalOpen,
            roomName: "", 
            roomId: ""
        }))
    }

    getSaveData = (data, type) => {
        let dataObject = {}
        if(type==="Building"){
            dataObject["building_id"] = data.buildingId
            dataObject["building_name"] = data.buildingName
            return [this.props.saveBuilding, dataObject]
        }
        else if(type==="Floor"){
            // Convert building to number and only send required fields
            const buildingId = parseInt(data.building);
            if (isNaN(buildingId)) {
                toast.error("Por favor, selecione um prédio válido!", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                return [false, false];
            }
            dataObject["building"] = buildingId
            dataObject["floor_name"] = data.floorName.trim()
            dataObject["floor_plan"] = data.floorPlan
            // Only add floor_plan_width if it exists
            if (data.floor_plan_width) {
                dataObject["floor_plan_width"] = data.floor_plan_width
            }
            return [this.props.saveFloor, dataObject]
        }
        else if(type==="Room"){
            dataObject["room_id"] = data.roomId
            dataObject["room_name"] = data.roomName
            return [this.props.saveRoom, dataObject]
        }
        else
            return [false, false]
    }
    
    saveData = (type) => {
        let [saveProp, data] = this.getSaveData(this.state, type)
        console.log('getSaveData returned:', { saveProp: !!saveProp, data, type });
        console.log('Current state:', { 
            building: this.state.building, 
            floorName: this.state.floorName, 
            floorPlan: this.state.floorPlan,
            floorPlanName: this.state.floorPlanName 
        });
        if (data && saveProp && this.validateData(this.state, type)) {
            console.log('Saving', type, 'with data:', data);
            console.log('floorPlan type:', typeof data.floor_plan, 'is File:', data.floor_plan instanceof File);
            if (data.floor_plan) {
                console.log('floorPlan details:', {
                    name: data.floor_plan.name,
                    size: data.floor_plan.size,
                    type: data.floor_plan.type
                });
            } else {
                console.error('floorPlan is missing!');
            }
            // Ensure floor_plan_width is a string (backend expects CharField)
            if (data.floor_plan_width !== undefined && data.floor_plan_width !== null) {
                data.floor_plan_width = String(data.floor_plan_width);
                console.log('floor_plan_width converted to string:', data.floor_plan_width);
            }
            saveProp(data).then(response => {
                    if (response.status === 201) {
                        if (appInsights && appInsights.trackEvent) {
                            appInsights.trackEvent({name: type+' Added'});
                        }
                        toast.success(type + "  is added successfully!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        if(type === "Floor"){
                            if (appInsights && appInsights.trackTrace) {
                                appInsights.trackTrace({message: type + "  is added successfully!", properties:{page: "addLocations", name: response.data.floor_name, id: response.data.floor_id}, severityLevel: SeverityLevel.Information});
                            }
                            this.props.fetchBuilding().then(()=>{
                            this.props.fetchFloors(response.data.building)
                            })
                            this.setState({
                                ...initialState,
                                building: response.data.building,
                                floor: response.data.id,
                                floorId: response.data.floor_id
                            }, async () => {
                                await this.applyfilter()})
                        }
                        else if(type==="Building"){
                            if (appInsights && appInsights.trackTrace) {
                                appInsights.trackTrace({message: type + "  is added successfully!", properties:{page: "addLocations", name: response.data.building_name, id: response.data.building_id}, severityLevel: SeverityLevel.Information});
                            }
                            this.props.fetchBuilding()
                            this.setState({isAddBuildingModalOpen: false, buildingId:"", buildingName:""})
                        }
                        else{
                            if (appInsights && appInsights.trackTrace) {
                                appInsights.trackTrace({message: type + "  is added successfully!", properties:{page: "addLocations", name: response.data.room_name, id: response.data.room_id}, severityLevel: SeverityLevel.Information});
                            }
                        this.getRooms()
                        this.setState({roomId:"", rommName:"",  isAddRoomModalOpen: false,})
                    }
                    }
                    else {
                        this.errorCheck(response, type)
                    }
                })
                    .catch((error) => {
                        console.error('Error saving', type, ':', error);
                        if (error.response) {
                            console.error('Error response:', error.response);
                            console.error('Error status:', error.response.status);
                            console.error('Error data:', error.response.data);
                            // Try to extract specific error messages
                            if (error.response.data) {
                                if (typeof error.response.data === 'object') {
                                    const errorKeys = Object.keys(error.response.data);
                                    console.error('Error fields:', errorKeys);
                                    errorKeys.forEach(key => {
                                        console.error(`  ${key}:`, error.response.data[key]);
                                    });
                                }
                            }
                        }
                        this.errorCheck(error.response, type);
                    })
        }
        else {
            this.ErrorDetails()
        }
    }

    errorCheck = (response, type) => {
        let errors = (response && response.data) || ""
        if (errors.building_id || errors.building_name || errors.building) {
            let message = "Invalid Building Details!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations", errors: errors}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        else if (errors.room_id || errors.room_name) {
            let message = "Invalid Room Details!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations", errors: errors}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        else if (errors.floor_id || errors.floor_name || errors.floor_plan) {
            let message = "Invalid Floor Details!"
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations", errors: errors}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        else if (errors.non_field_errors) {
            // Handle Django REST Framework non_field_errors (e.g., uniqueness constraints)
            let message = Array.isArray(errors.non_field_errors) 
                ? errors.non_field_errors.join(', ') 
                : errors.non_field_errors;
            // Translate common messages
            if (message.includes('must make a unique set')) {
                message = "Já existe um andar com este nome neste prédio. Por favor, escolha um nome diferente.";
            }
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: message, properties:{page: "addLocations", errors: errors}, severityLevel: SeverityLevel.Error});
            }
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
        else{
            if (appInsights && appInsights.trackTrace) {
                appInsights.trackTrace({message: type + " couldn't be added !", properties:{page: "addLocations", errors: errors}, severityLevel: SeverityLevel.Error});
            }
            toast.error(type + " couldn't be added !", {
                position: toast.POSITION.BOTTOM_RIGHT
            })
        }
    }

    ErrorDetails = () => {
        if (appInsights && appInsights.trackTrace) {
            appInsights.trackTrace({message: errorDetails, properties:{page: "addLocations"}, severityLevel: SeverityLevel.Verbose});
        }
        toast.error(errorDetails, {
            position: toast.POSITION.BOTTOM_RIGHT
        })
        errorDetails = ""
        return true
    }

    handleFormSubmit (text) {
        return event => {
            event.preventDefault()
            this.saveData(text)
        }
      }

    resetData = (type) => {
        if(type==="Building")
            this.toggleAddBuildingModal()
        else if(type==="Floor")
            this.toggleAddFloorModal()
        else if(type==="Room")
            this.toggleAddRoomModal()
        else
        this.setState({
            ...initialState,
        })
    }

    cancelData = () => {
        this.setState(initialState)
    }


    handleError = (err) => {
        console.error(err)
    }

    onChangeFile = event => {
        const file = event.target.files[0];
        console.log('onChangeFile called, file:', file);
        if (file) {
            // Clean up previous object URL if exists
            if (this.state.image) {
                URL.revokeObjectURL(this.state.image);
            }
            this.setState({
                floorPlan: file,
                floorPlanName: file.name,
                image: URL.createObjectURL(file)
            }, () => {
                console.log('State updated with floorPlan:', this.state.floorPlan);
            })
        } else {
            console.warn('No file selected!');
        }
    }

    onImageLoad = event => {
        let floor_width = 1268
        this.setState({
            floor_plan_width: floor_width<event.target.naturalWidth?floor_width:event.target.naturalWidth
        })
    }

    validateData = (data, type) => {
    if(type==="Building"){
        if (data.buildingName.trim().length > 0) {
            return true
        }
        else{
            errorDetails = "Building Name is required to create a Building!"
            return false
        }
    }
    else if(type==="Floor"){
        if (data.floorName.trim().length > 0 && data.building && data.floorPlan) {
            return true
        }
        else if (!data.building) {
            errorDetails = "Select the Building from the drop down"
            return false
        }
        else if (!data.floorPlan) {
            errorDetails = "Uplaod a FloorPlan!"
            return false
        }
        else{
            errorDetails = "All *mandatory fields are required to create a Room!"
            return false
        }
    }
    else if(type==="Room"){
        if (data.roomName.trim().length > 0) {
            return true
        }
        else{
            errorDetails = "Room Name is required to create a Room!"
            return false
        }
    }
    }

    render() {
        return (
            <div className="manage-page page-layout" data-tut="reactour__addLocations" >
                <NavBar />
                <div className={window.innerWidth>900?"dashboard-overview samples-page": "dashboard-overview-100 samples-page"}>
                    <div className="dashboard-content-25 " ref={(divElement) => { this.divElement = divElement }}>
                        <Row className=" manage-page-header mt-0" form>
                            <Navbar className="navbar-results " light expand="md">
                            <Nav navbar data-tut="reactour__nav">
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/buildings/addbuildings"><span className="nav-col manage-building"><img src={radioButtonhighlighted} className = "nav-icons" alt=''/>Manage Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/locations"><span className="nav-col"><img src={radioButton} className = "nav-icons" alt=''/>View Locations</span></NavLink>
                                    <NavLink tag={RRNavLink} className="manage-nav-link" activeClassName="active" to="/manage/notifications/"><span className="nav-col"><img src={radioButton} className = "nav-icons" alt=''/>Manage Notifications</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                    </div>
                    <div className="sample-list-header building-heading grid-data">
                            <NavLink 
                                tag={RRNavLink} 
                                className="open-building-modal" 
                                style={{color: this.state.showBuildings? '#F38238DB' : '#6676AA', borderBottom: this.state.showBuildings? '4px solid #ee7d11':'', borderRadius: this.state.showBuildings?'4px':'' }}
                                to={{
                                    pathname:"/manage/buildings/addbuildings",
                                    aboutProps:{
                                          showBuildings:true
                                         }
                                    }}
                                    exact
                            >
                                {this.state.showBuildings?
                                    <img src={listHighlight} className="nav-icons" alt=''/>:
                                    <img src={list} className="nav-icons" alt=''/>
                                }    
                                Buildings and Floors
                            </NavLink>
                            <NavLink 
                                tag={RRNavLink} 
                                className="open-room-modal" 
                                style={{color: this.state.showRooms? '#F38238DB' : '#6676AA', borderBottom: this.state.showRooms? '4px solid #ee7d11':'', borderRadius: this.state.showRooms?'4px':''  }} 
                                to={{
                                    pathname:"/manage/buildings/addbuildings",
                                    aboutProps:{
                                          showRooms:true
                                         }
                                    }}
                                    exact
                            >
                                {this.state.showRooms?
                                    <img className="nav-icons" src={listHighlight} alt=''/>:
                                    <img className="nav-icons" src={list} alt=''/>
                                }
                                Rooms
                            </NavLink>
                            <NavLink 
                                tag={RRNavLink} 
                                className="open-room-modal map-locations" 
                                to="#"
                            >
                                <img className="nav-icons" src={mapLocation} width="25px" alt=''/>
                                Map Locations
                            </NavLink>
                        </div>
                    <div className="grid-data" >
                        <Row className="sample-list-header" form >
                            <Col className="building-heading" sm={4} md={6}>
                                <p className="building-label">Building Name:</p>
                                <p className="building-label">
                                {this.props.location.state? this.props.location.state.buildingName
                                : 
                                <NavLink 
                                tag={RRNavLink} 
                                className="open-building-modal select-floorplan" 
                                style={{color: this.state.showBuildings? '#F38238DB' : '#6676AA', borderBottom: this.state.showBuildings? '4px solid #ee7d11':'', borderRadius: this.state.showBuildings?'4px':'' }}
                                to={{
                                    pathname:"/manage/buildings/addbuildings",
                                    aboutProps:{
                                          showBuildings:true
                                         }
                                    }}
                                    exact
                            >    
                                Please go to <b>Buildings and Floors</b> and select the FloorPlan you wish to see!
                            </NavLink> 
                            } 
                            </p>
                            
                                {this.state.loader ? <Spinner className="ml-md-3 ml-lg-3 ml-xl-3" size="sm" color="primary" /> : null}
                            </Col>
                            <Col className="location-header" data-tut="reactour__add" >
                                <Button id="add-unit-button" className="add-unit-button" onClick={this.toggleAddRoomModal}><span className="add-unit-icon">+</span> Room</Button>
                                <Button id="add-unit-button" className="add-unit-button" onClick={this.toggleAddBuildingModal}><span className="add-unit-icon">+</span> Building</Button>
                                <Button id="add-unit-button" className="add-unit-button" onClick={this.toggleAddFloorModal}><span className="add-unit-icon">+</span> Floor</Button>

                            </Col>
                        </Row>
                        <div >
                            {this.state.floor_plan ?
                                <>
                                    <div data-tut="reactour__floor" className="canvas-position">
                                    <h4 className="floor-heading"><abbr className="floor-heading-tooltip" title="Floor Name">{this.props.location.state? this.props.location.state.floorName : null}</abbr></h4>
                                    <p className="floorPlanInstructions">Drag a shape on the map to create a room</p>
                                        <Canvas
                                            addRooms={this.toggleAddRoomModal}
                                            width={this.state.width}
                                            height={this.state.height}
                                            rooms={this.state.rooms}
                                            fetchRooms={this.getRooms}
                                            image={this.state.floor_plan}
                                            floor={{ "floor": this.state.floorId, "id": this.state.floor, "floorName": this.state.floorName }}
                                            building={{ "building": this.state.buildingId, "id": this.state.building, "buildingName": this.state.buildingName }}
                                            fetchLocations={this.applyfilter}
                                        />
                                    </div>
                                </>
                                :
                                <Row>
                                <Col className="map-location-text"> Please wait while we construct your floorplan!</Col>
                                </Row>}
                        </div>
                    </div>
                </div>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddFloorModalOpen} toggle={this.toggleAddFloorModal}>
                    <ModalHeader toggle={this.toggleAddFloorModal} className="edit-popup hover-move">Add a Floor</ModalHeader>
                    <ModalBody className="edit-popup-alignment">
                        <Form onSubmit={this.handleFormSubmit("Floor")}>
                            <FormGroup>
                                <Label className="location-label-names">Building <span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="select" name="building" id="Building" value={this.state.building} onChange={this.handleChange} size="1">
                                    <option value="" default disabled>Building</option>
                                    {this.props.buildingList.map((building, key) => {
                                        return <option id={building.building_id} key={key} value={building.id}>{building.building_name}</option>
                                    })}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label className="location-label-names">Floor Name<span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="text" name="floorName" id="FloorName" value={this.state.floorName} onChange={this.handleChange} size="1" placeholder="Ex: Floor 1" />
                            </FormGroup>
                            <FormGroup>
                                <FontAwesomeIcon className="overlay-upload-icon upload-icon-position"  icon={faUpload} size="lg" />
                                <Input
                                    className="edit-input-values edit-input-values-file input-upload"
                                    type="file"
                                    accept='image/*'
                                    placeholder="please enter file"
                                    onChange={this.onChangeFile}
                                    key={this.state.floorPlanName || 'file-input'}
                                    data-title={this.state.floorPlanName || 'Upload Floorplan Image*'}
                                />
                                {this.state.floorPlan ? <img src={this.state.image} onLoad={this.onImageLoad} width="0" height="0" alt=''/> : null}
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                    <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData("Floor")}>Cancel</Button>
                            <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveData("Floor")}>Save</Button>
                    </ModalFooter>
                </Modal>
                </Draggable>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddBuildingModalOpen} toggle={this.toggleAddBuildingModal}>
                    <ModalHeader toggle={this.toggleAddBuildingModal} className="edit-popup hover-move">Add a Building</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleFormSubmit("Building")}>
                            <FormGroup>
                                <Label className="location-label-names">Building Name<span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="text" name="buildingName" id="BuildingName" value={this.state.buildingName} onChange={this.handleChange} size="1" placeholder="Ex: Building A" />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData("Building")}>Cancel</Button>
                        <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveData("Building")}>Save</Button>
                    </ModalFooter>
                </Modal>
                </Draggable>
                <Draggable handle=".edit-popup" bounds={{top: -10, left: -225, right: 250, bottom: 400}}>
                <Modal isOpen={this.state.isAddRoomModalOpen} toggle={this.toggleAddRoomModal}>
                    <ModalHeader toggle={this.toggleAddRoomModal} className="edit-popup hover-move">Add a Room</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={this.handleFormSubmit("Room")}>
                            <FormGroup>
                                <Label className="location-label-names">Room Name<span className="required-icon">*</span></Label>
                                <Input className="add-location-unit" type="text" name="roomName" id="RoomName" value={this.state.roomName} onChange={this.handleChange} size="1" placeholder="Ex: Cold Room 1" />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="float-sm-right bottom-options">
                        <Button className="button-size custom-button cancel-button mr-2" outline color="secondary" onClick={() => this.resetData("Room")}>Clear</Button>
                        <Button className="button-size custom-button save-upload-delete-button" id="save" onClick={() => this.saveData("Room")}>Save</Button>
                    </ModalFooter>
                </Modal>
                </Draggable>
                {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                <ToastContainer autoClose={3000} />
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchBuilding,
        saveBuilding,
        deleteBuilding,
        fetchFloor,
        saveFloor,
        deleteFloor,
        fetchRooms,
        saveRoom,
        deleteRoom,
        fetchLocationData,
        fetchFloors
    }
)(AddLocations), 'Map Locations', 'AddLocations');